import { FC, ReactElement } from 'react'

interface UserCalendarDayHeaderProps {
    header: string
    className?: string
}

const UserCalendarDayHeader: FC<UserCalendarDayHeaderProps> = ({
    header,
    className = '',
}): ReactElement => (
    <div className={`user-calendar-day-header ${className}`}>
        <span className="user-calendar-day-header__day">
            {header}
        </span>
    </div>
)

export default UserCalendarDayHeader
